import request from "./useRequests";
import qsRequest from "@/api/qsRequest";

export default function addViews() {
  async function viewing() {
    try {
      const res = await request.put('/back/addVisitsCount')
      // console.log(res)
    } catch (err: any) {
      console.warn(err);
    }
  }

  async function viewArticle(id: number) {
    try {
      const res = await request.put('/news/viewsAdd', {
        id: id,
        type: 1
      })

        // 增加qs统计view
        await qsRequest.post('/newsView', {
            news_id: id
        })

    } catch (err: any) {
      console.warn(err);
    }
  }

  return {
    viewing,
    viewArticle
  }
}